import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const DashboardWalletInfoContainer = styled.div``;

export const BodyLoader = styled(ContentLoader)`
  height: 7.5rem;
  width: 100%;
`;

export const AssetIcons = styled.circle`
  r: 1.7rem;
  cx: 2.7rem;
  cy: 3.4rem;

  ${({ theme }) => theme.media.laptop`
      cx: 2.1rem;
  `};
`;

export const AssetName = styled.rect`
  height: 1.8rem;
  width: 7rem;

  x: 5.4rem;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 5.2rem;
  `};
`;

export const AssetCode = styled.rect`
  height: 1.6rem;
  width: 8rem;

  x: 5.4rem;
  y: 3.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 5.2rem;
  `};
`;

export const Amount = styled.rect`
  /* display: none; */

  height: 1.8rem;
  width: 8.5rem;

  x: 65%;
  y: 1.4rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 63%;
    y: 1.4rem;
  `};
`;

export const AmountSecond = styled.rect`
  height: 1.5rem;
  width: 11.5rem;

  x: 57%;
  y: 3.5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  ${({ theme }) => theme.media.laptop`
    x: 56%;
    y: 3.5rem;
  `};
`;

export const ArrowIcon = styled.circle`
  r: 1.2rem;
  cx: 94%;
  cy: 3.4rem;

  ${({ theme }) => theme.media.laptop`
      cx: 91%;
  `};
`;
